module.exports = __webpack_public_path__ + "img/06.adc64c4f.jpg";